import { render, staticRenderFns } from "./entryRegistration.vue?vue&type=template&id=c734595e&scoped=true&"
import script from "./entryRegistration.vue?vue&type=script&lang=js&"
export * from "./entryRegistration.vue?vue&type=script&lang=js&"
import style0 from "./entryRegistration.vue?vue&type=style&index=0&id=c734595e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c734595e",
  null
  
)

export default component.exports